(function () {
  'use strict';

  var root = document.querySelector('[data-bt-store-selector]');
  if (!root) return;

  var sheet = root.querySelector('[data-bt-selector-sheet]');
  var currencyPanel = root.querySelector('[data-bt-selector-panel="currency"]');
  var usesShopifyMarkets = root.getAttribute('data-currency-mode') === '1';
  var marketCurrency = String(root.getAttribute('data-current-currency') || '').toUpperCase();
  var returnFocus = null;
  var closeTimer = 0;
  var dragState = null;
  var openSequence = 0;
  var closeDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 20 : 330;
  var countryByCurrency = {
    OMR: { iso: 'om', ar: 'عُمان', en: 'Oman' },
    SAR: { iso: 'sa', ar: 'السعودية', en: 'Saudi Arabia' },
    AED: { iso: 'ae', ar: 'الإمارات', en: 'United Arab Emirates' },
    KWD: { iso: 'kw', ar: 'الكويت', en: 'Kuwait' },
    BHD: { iso: 'bh', ar: 'البحرين', en: 'Bahrain' },
    QAR: { iso: 'qa', ar: 'قطر', en: 'Qatar' },
    USD: { iso: 'us', ar: 'الولايات المتحدة', en: 'United States' },
    GBP: { iso: 'gb', ar: 'المملكة المتحدة', en: 'United Kingdom' },
    EUR: { iso: 'eu', ar: 'الاتحاد الأوروبي', en: 'European Union' }
  };

  function setScrollLock(locked) {
    document.documentElement.classList.toggle('bt-store-selector-open', locked);
    document.body.classList.toggle('bt-store-selector-open', locked);
  }

  function currentCurrency() {
    try {
      var saved = localStorage.getItem('hdt_currency_iso') || localStorage.getItem('T4Currency') || '';
      return String(saved).toUpperCase().split('|')[0].replace(/[^A-Z]/g, '').slice(0, 3);
    } catch (_) {
      return '';
    }
  }

  function optionCode(option) {
    return String(option.getAttribute('value') || '')
      .toUpperCase()
      .split('|')[0]
      .replace(/[^A-Z]/g, '')
      .slice(0, 3);
  }

  function syncTriggerCountry(code) {
    var normalized = String(code || '').toUpperCase().split('|')[0].replace(/[^A-Z]/g, '').slice(0, 3);
    if (!normalized) return;
    var details = countryByCurrency[normalized];
    var language = String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'en' : 'ar';

    document.querySelectorAll('.bt-store-preferences').forEach(function (trigger) {
      var name = trigger.querySelector('[data-bt-country-current]');
      var flag = trigger.querySelector('[data-bt-country-flag]');
      var currency = trigger.querySelector('[data-name-current]');
      if (currency) currency.textContent = normalized;
      if (name && details) name.textContent = details[language];
      if (flag && details) {
        flag.src = '//cdn.shopify.com/static/images/flags/' + details.iso + '.svg';
        flag.removeAttribute('srcset');
      }
    });
  }

  function syncCurrencySelection() {
    var panel = root.querySelector('[data-bt-selector-panel="currency"]');
    if (!panel) return;
    if (panel.getAttribute('data-bt-currency-mode') === '1') return;

    var code = currentCurrency();
    if (!code) {
      var currentLabel = document.querySelector('[data-name-current]');
      code = currentLabel ? String(currentLabel.textContent || '').trim().toUpperCase() : '';
    }
    if (!code) return;
    syncTriggerCountry(code);

    panel.querySelectorAll('.bt-selector-options > button[value]').forEach(function (option) {
      var selected = optionCode(option) === code;
      option.classList.toggle('k5d-current', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function updateTriggerState(isOpen) {
    document.querySelectorAll('[data-bt-selector-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function activatePanel(name, focusTab) {
    var panelName = name === 'currency' ? 'currency' : 'language';

    root.querySelectorAll('[data-bt-selector-tab]').forEach(function (tab) {
      var selected = tab.getAttribute('data-bt-selector-tab') === panelName;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && focusTab) tab.focus({ preventScroll: true });
    });

    root.querySelectorAll('[data-bt-selector-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-bt-selector-panel') !== panelName;
    });

    if (panelName === 'currency') syncCurrencySelection();
  }

  function focusInitialControl(panelName) {
    var panel = root.querySelector('[data-bt-selector-panel="' + panelName + '"]');
    var selected = panel && panel.querySelector('[aria-selected="true"]');
    var activeTab = root.querySelector('[data-bt-selector-tab="' + panelName + '"]');
    var target = selected || activeTab || sheet;
    if (target) target.focus({ preventScroll: true });
  }

  function openSelector(opener, panelName) {
    window.clearTimeout(closeTimer);
    var sequence = ++openSequence;
    returnFocus = opener || document.activeElement;
    sheet.style.setProperty('--bt-selector-y', '0px');
    sheet.classList.remove('is-dragging');
    root.classList.remove('is-closing');
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    if (typeof root.showModal === 'function' && !root.open) {
      try {
        root.showModal();
      } catch (_) {
        try { root.show(); } catch (__) {}
      }
    }
    activatePanel(panelName, false);
    setScrollLock(true);
    updateTriggerState(true);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (sequence !== openSequence || root.hidden) return;
        root.classList.add('is-open');
        focusInitialControl(panelName === 'currency' ? 'currency' : 'language');
      });
    });
  }

  function finishClose(restoreFocus) {
    openSequence += 1;
    root.classList.remove('is-open', 'is-closing');
    root.setAttribute('aria-hidden', 'true');
    sheet.classList.remove('is-dragging');
    sheet.style.setProperty('--bt-selector-y', '0px');
    setScrollLock(false);
    updateTriggerState(false);

    if (typeof root.close === 'function' && root.open) {
      try { root.close(); } catch (_) {}
    }
    root.hidden = true;

    if (restoreFocus !== false && returnFocus && typeof returnFocus.focus === 'function' && document.documentElement.contains(returnFocus)) {
      returnFocus.focus({ preventScroll: true });
    }
    returnFocus = null;
  }

  function closeSelector() {
    if (root.hidden || root.classList.contains('is-closing')) return;
    openSequence += 1;
    root.classList.remove('is-open');
    root.classList.add('is-closing');
    sheet.classList.remove('is-dragging');
    sheet.style.setProperty('--bt-selector-y', '0px');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(finishClose, closeDuration);
  }

  function visibleFocusable() {
    return Array.prototype.filter.call(
      sheet.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return !element.hidden && element.getClientRects().length > 0;
      }
    );
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-bt-selector-open]');
    if (!opener) return;

    event.preventDefault();
    var clickedArea = event.target.closest && event.target.closest('[data-bt-selector-panel-target]');
    var requestedPanel = clickedArea && opener.contains(clickedArea)
      ? clickedArea.getAttribute('data-bt-selector-panel-target')
      : opener.getAttribute('data-bt-selector-panel-target');
    openSelector(opener, requestedPanel || 'language');
  });

  root.addEventListener('click', function (event) {
    var closeButton = event.target.closest && event.target.closest('[data-bt-selector-close]');
    if (closeButton) {
      event.preventDefault();
      closeSelector();
      return;
    }

    var tab = event.target.closest && event.target.closest('[data-bt-selector-tab]');
    if (tab) {
      activatePanel(tab.getAttribute('data-bt-selector-tab'), false);
      return;
    }

    var currencyOption = event.target.closest && event.target.closest(
      '[data-bt-selector-panel="currency"] .bt-selector-options > button[value]'
    );
    if (currencyOption) {
      var currencyPanel = currencyOption.closest('[data-bt-selector-panel="currency"]');
      var usesShopifyMarkets = currencyPanel && currencyPanel.getAttribute('data-bt-currency-mode') === '1';
      var selectedCurrency = usesShopifyMarkets
        ? String(currencyOption.getAttribute('data-currency-code') || '').toUpperCase()
        : optionCode(currencyOption);
      syncTriggerCountry(selectedCurrency);

      if (usesShopifyMarkets) {
        try {
          localStorage.setItem('bt_policy_country_iso', String(currencyOption.getAttribute('data-country-code') || currencyOption.value || '').toUpperCase());
        } catch (_) {}
      }
      var options = currencyOption.parentElement.querySelectorAll('button[value]');
      options.forEach(function (option) {
        var selected = option === currencyOption;
        option.classList.toggle('k5d-current', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      if (currencyOption.type !== 'submit') {
        window.setTimeout(closeSelector, 180);
      }
    }
  });

  root.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('[data-bt-selector-filter]');
    if (!input) return;

    var panel = input.closest('[data-bt-selector-panel]');
    var query = String(input.value || '').trim().toLocaleLowerCase();
    var visibleCount = 0;

    panel.querySelectorAll('[data-bt-selector-filter-value]').forEach(function (option) {
      var value = String(option.getAttribute('data-bt-selector-filter-value') || option.textContent || '')
        .toLocaleLowerCase();
      var visible = !query || value.indexOf(query) !== -1;
      option.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    var emptyState = panel.querySelector('[data-bt-selector-empty]');
    if (emptyState) emptyState.hidden = visibleCount !== 0;
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeSelector();
      return;
    }

    if (event.key !== 'Tab') return;
    var controls = visibleFocusable();
    if (!controls.length) {
      event.preventDefault();
      sheet.focus();
      return;
    }

    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  root.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeSelector();
  });

  sheet.addEventListener('pointerdown', function (event) {
    var dragZone = event.target.closest && event.target.closest('[data-bt-selector-drag], .bt-selector-sheet__header');
    if (!dragZone || event.button !== 0) return;
    if (event.target.closest('button, input, select, textarea, a')) return;

    dragState = {
      pointerId: event.pointerId,
      startY: event.clientY,
      lastY: event.clientY,
      startTime: Date.now()
    };

    sheet.classList.add('is-dragging');
    try {
      dragZone.setPointerCapture(event.pointerId);
    } catch (_) {}
  });

  document.addEventListener('pointermove', function (event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;
    var distance = Math.max(0, event.clientY - dragState.startY);
    dragState.lastY = event.clientY;
    sheet.style.setProperty('--bt-selector-y', distance + 'px');
    if (distance > 2 && event.cancelable) event.preventDefault();
  }, { passive: false });

  function endDrag(event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;

    var state = dragState;
    dragState = null;
    var distance = Math.max(0, state.lastY - state.startY);
    var elapsed = Math.max(1, Date.now() - state.startTime);
    var velocity = distance / elapsed;

    sheet.classList.remove('is-dragging');
    if (distance > 90 || velocity > .55) {
      closeSelector();
      return;
    }

    sheet.style.setProperty('--bt-selector-y', '0px');
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('currency:applied', function (event) {
    syncTriggerCountry(usesShopifyMarkets ? marketCurrency : (event && event.detail && event.detail.currency));
    syncCurrencySelection();
  });
  syncTriggerCountry(usesShopifyMarkets ? marketCurrency : currentCurrency());

  window.addEventListener('pagehide', function () {
    window.clearTimeout(closeTimer);
    finishClose(false);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    window.clearTimeout(closeTimer);
    finishClose(false);
  });
})();
